import React from 'react';
import { SwiperSlide } from 'swiper/react';

import {
    Carousel,
    CarouselArrowNavigation,
    CarouselWrapper
} from '$partials/base/carousel';

import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TestimonialsBlock}
 */
const Testimonials = ({
    testimonials,
    title
}) => {
    return (
        <section className='col-wrapper-breakout bg-surface-panel-white rounded-lg py-32 flex-grow'>
            <h2 className='col-padding type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                {title}
            </h2>

            <Carousel swiperConfig={{
                a11y: { enabled: true },
                slidesPerView: 1.2,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                breakpoints: {
                    992: {
                        slidesPerView: 2.35,
                    },
                    1440: {
                        slidesPerView: 3.15,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    }
                },
                spaceBetween: 8,
                grabCursor: false,
            }}>
                <div className='w-full col-padding flex justify-end mb-16 mt-20 md:mt-12'>
                    <div className='flex'>
                        {/* Desktop */}
                        {testimonials?.length > 3 && (
                            <div className='hidden md:block ml-8 md:ml-16'>
                                <CarouselArrowNavigation />
                            </div>
                        )}

                        {/* Tablet */}
                        {testimonials?.length > 2 && (
                            <div className='hidden sm:block md:hidden ml-8 md:ml-16'>
                                <CarouselArrowNavigation />
                            </div>
                        )}
                    </div>
                </div>

                <div className='col-padding'>
                    <CarouselWrapper>
                        {testimonials?.map((testimonial, idx) => {
                            if (!testimonial) { return null; }

                            return (
                                <SwiperSlide
                                    aria-roledescription='slide'
                                    className='select-none cursor-pointer flex flex-wrap mt-4'
                                    key={testimonial.id + '-' + idx}
                                    role='group'>
                                    <div
                                        className='flex flex-col'
                                        key={testimonial.id}>
                                        <Media {
                                            ...{
                                                ...testimonial.media,
                                                ...(testimonial.media.videoEmbed ? {
                                                    videoEmbed: {
                                                        ...testimonial.media.videoEmbed,
                                                        poster: testimonial.media?.videoEmbed?.poster || testimonial.media?.videoEmbed?.embed?.thumbnailUrl
                                                    }
                                                } : {} )
                                            }
                                        } />

                                        <p className='type-style-serif-h4 mt-16'>
                                            {testimonial.quote}
                                        </p>

                                        <p className='type-style-sans-body-med mt-16'>
                                            {testimonial.name}
                                        </p>

                                        <p className='type-style-sans-body'>
                                            {testimonial.role}
                                        </p>
                                    </div>
                                </SwiperSlide>
                            );
                        }).filter(Boolean)}
                    </CarouselWrapper>
                </div>
            </Carousel>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Testimonials;
